import React from "react";
import axios from "axios";

export default function PricingPlans() {
  const handleBuy = async (plan) => {
    try {
      // 🔹 Kullanıcı bilgileri (formdan veya profilinizden alabilirsiniz)
      const user_uid = "8RhJRfvsmQhaTpf6Nt3GrdFi1sM2"; // Mevcut giriş yapan kullanıcı UID
      const email = "ali@gmail.com"; // Kullanıcı email
      const user_name = "Ali Veli"; // Ad Soyad
      const user_address = "İstanbul, Türkiye"; // Adres
      const user_phone = "05555555555"; // Telefon

      const plans = {
        BIREYSEL: 100000, // 1000 TL
        KURUM: 1000000, // 10000 TL
      };

      const amount = plans[plan];

      console.log("SATIN AL İSTEĞİ:", {
        user_uid,
        plan_code: plan,
        email,
        amount,
        user_name,
        user_address,
        user_phone,
      });

      const res = await axios.post("http://localhost:8080/api/paytr/init", {
        user_uid,
        plan_code: plan,
        email,
        amount,
        user_name,
        user_address,
        user_phone,
      });

      if (res.data.payment_url) {
        window.location.href = res.data.payment_url; // Ödeme sayfasına yönlendir
      } else {
        alert("Ödeme başlatılamadı!");
      }
    } catch (err) {
      console.error("Ödeme başlatma hatası:", err);
      alert("Ödeme başlatma sırasında bir hata oluştu!");
    }
  };

  return (
    <div>
      <h1>Plan Seç</h1>
      <button onClick={() => handleBuy("BIREYSEL")}>
        Bireysel Plan Satın Al
      </button>
      <button onClick={() => handleBuy("KURUM")}>Kurum Planı Satın Al</button>
    </div>
  );
}
